import TopBar from "../../components/Layout/TopBar";
import MySelect from "../../components/Layout/MySelect";
import React, {useEffect, useState} from "react";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import {logError} from "../../components/Utils/FormatData";
import MyDatePicker from "../../components/Layout/MyDatePicker";
import {useAlert} from 'react-alert';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark, faPlus, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons';
import MyComboBox from "../../components/Layout/MyComboBox";
import moment from "moment";
import useAuthz from "../../hooks/useAuthz";
import {useNavigate} from 'react-router';
import MyDialog from "../../components/Layout/MyDialog";
import MyButton from "../../components/Layout/MyButton";

const grilleTarifaireStyle = {
	cellHeader: {fontSize: '12px', color: 'white', border: '0', borderRight: '1px solid #ffffff4d', textTransform: 'uppercase', minWidth: '65px'},
	rowDeleted: {backgroundColor: '#5a6e7430'},
	iconTable: {color: '#bb0060', height: '13px', padding: '0 10px', cursor: 'pointer'},
	classicInput: {border: 'none', borderBottom: '1px solid #5d6770', outline: 'none', width: '100%'}
};

const BlackList = (props) => {
	const [listeLitiges, setListeLitiges] = useState([]);
	const [listeUtilisateurs, setListeUtilisateurs] = useState([]);
	const [selectedValue, setSelectedValue] = useState({filterSelected: 1});
	const [deletedSelected, setDeletedSelected] = useState({deletedSelected: 2});
	const [isLoading, setIsLoading] = useState(true);
	const [newRow, setNewRow] = useState([{dateDebutLitige: moment(), dateFinLitige: null}])
	const alert = useAlert();
	const [content, setContent] = useState('');
	const [authz, user, profil] = useAuthz();
	const [dialogData, setDialogData] = useState({type: '', data: {}});
	const [openDialog, setOpenDialog] = useState(false);
	const [dialogState, setDialogState] = useState(null);
	const [options, setOptions] = useState([])
	const [needReload, setNeedReload] = useState(false)
	const [file, setFile] = useState(null);
	const navigate = useNavigate();

	//#region Fonctions

	useEffect(() => {
		if (dialogState && dialogData.data) {
			switch (dialogData.type) {
				case 'delete':
					callApiDelete(dialogData.data);
					break;
			}
		}
		setDialogState(null);
	}, [dialogState]);
	useEffect(() => {
		if (profil.profil === 6) {
			alert.error('Vous n\'êtes pas autorisé à accéder à la blacklist');
			navigate('/');
		}
		document.title = 'TE - Gestion des litiges';
		getLitigesList();
	}, []);
	useEffect(() => {
		if (needReload) {
			getLitigesList();
			setNeedReload(false);
		}
	}, [needReload])
	useEffect(() => {
		if (file !== null) {
			callApiUploadBlacklistFile();
			document.getElementById('fileSelect').value = null;
			setFile(null);
		}
	}, [file]);

	const changeSelectValue = (e) => {
		setSelectedValue({...selectedValue, [e.target.name]: e.target.value})
		setNeedReload(true)
	};
	const changeSelectedDeletedValue = (e) => {
		setDeletedSelected({...deletedSelected, [e.target.name]: e.target.value})
	};
	const isAlreadyBlacklisted = (user_id) => {
		let valueIsValid = false;
		listeLitiges.map((litige) => {
			if (litige.user_id === user_id && litige.deleted === false) {
				valueIsValid = true;
			}
		})
		return !valueIsValid;
	}
	const getUser_id = (userName) => {
		let user_id = '';
		listeUtilisateurs.map((utilisateur) => {
			if (utilisateur.raison_sociale === userName) {
				user_id = utilisateur.user_id
			}
		})
		return user_id;
	}
	const addNewDispute = () => {
		let valueIsValid = true;
		let user_id = getUser_id(document.getElementById('select-user').value)
		let date_debut_litige = newRow[0].dateDebutLitige;
		let date_fin_litige = newRow[0].dateFinLitige;
		let deleted = deletedSelected.deletedSelected === 1; //if equal to 1 isDeleted
		if (user_id === '' || date_debut_litige === null || deleted === '') {
			alert.error('Vous devez remplir les champs obligatoires avant de continuer !');
			valueIsValid = false;
			return;
		}
		if (date_fin_litige !== null) {
			if (moment(date_fin_litige).isBefore(moment(date_debut_litige))) {
				alert.error('La date de fin du litige ne peut pas être avant la date du début du litige !');
				valueIsValid = false;
				return;

			}
		}
		if (valueIsValid) {
			valueIsValid = (isAlreadyBlacklisted(user_id)) // must check if the user is not already in the array
		}
		if (valueIsValid) {
			callApiAdd({
				user_id: user_id, date_debut_litige: date_debut_litige, date_fin_litige: date_fin_litige ? date_fin_litige : null, deleted: deleted
			})
		} else {
			alert.error('Cet utilisateur est déjà présent dans la blackist !');
		}
	};
	const addDate = (indice, name, value) => {
		let tmp = [...newRow];
		let aTarif = tmp[0];
		aTarif[name] = value
		setNewRow(tmp)
	}
	const handleOnDelete = (element) => {
		setDialogData({...dialogData, data: element, type: 'delete'});
		setContent(() => {
			return (<>
				<div>Êtes-vous sûr de vouloir supprimer le <b>litige n°{element.litige_id}</b>, concernant <b>{element.userName}</b> ?</div>
			</>)
		});
		setOpenDialog(true);
	};
	const uploadDocument = (e) => {
		let uploadFile = e.target.files[0];

		if (uploadFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
			uploadFile.dateUpload = moment();
			setFile(uploadFile);
		} else {
			alert.error("Ce type de fichier n'est pas pris en charge, merci de choisir un document .xlsx");
			setFile(null);
		}
	};
	const selectFile = () => {
		document.getElementById('fileSelect').click();
	}

	//#endregion

	//#region API

	const callApiAdd = (litige) => {
		axios({method: 'post', url: `${URL_API}/blacklist/add`, data: litige, params: {userAction: user.user_id}})
		.then(() => {
			alert.removeAll();
			alert.success('L\'ajout du litige a bien été effectué ! ');
			setNeedReload(true)
		})
		.catch((error) => {
			alert.removeAll();
			alert.error(error.response.data.message);
		});
	};
	const callApiDelete = (litige) => {
		axios({method: 'post', url: `${URL_API}/blacklist/delete`, params: {litige_id: litige.litige_id, userAction: user.user_id}})
		.then(() => {
			alert.removeAll();
			alert.success('La suppression du litige a bien été effectuée ');
			setNeedReload(true)
		})
		.catch((error) => {
			alert.removeAll();
			alert.error(error.response.data.message);
		});
	};
	const getLitigesList = () => {
		let tabUsers = []
		let tabLitiges = [];
		let tmp = [];
		let deleted;
		if (selectedValue.filterSelected === 3) deleted = ''; else deleted = selectedValue.filterSelected !== 1;
		const promiseListLitiges = axios({method: 'get', url: URL_API + '/blacklist/full-list', params: {deleted: deleted}});
		const promiseListUsers = axios({method: 'get', url: URL_API + '/utilisateur/liste', params: {deleted: ''}});
		Promise.all([promiseListLitiges, promiseListUsers])
		.then(function (values) {
			values[0].data.forEach((elt) => {
				tabLitiges.push({
					litige_id: elt.litige_id,
					user_id: elt.user_id,
					date_debut_litige: elt.date_debut_litige,
					date_fin_litige: elt.date_fin_litige,
					deleted: elt.deleted,
					userName: elt.account.raison_sociale
				})
			})
			values[1].data.map((User) => {
				if (User.raison_sociale !== null) tmp.push(User.raison_sociale);
				tabUsers.push(User)
			})
			setListeUtilisateurs(tabUsers)
			setOptions(tmp);
			setListeLitiges(tabLitiges);
			setIsLoading(false)
		})
		.catch(function (err) {
			logError(alert, err);
		});
	};
	const callApiUploadBlacklistFile = () => {
		const formData = new FormData();
		formData.append("blacklistFile", file);
		formData.append("userAction", user.user_id);

		axios({method: 'post', url: `${URL_API}/blacklist/upload-file`, data: formData})
		.then(() => {
			alert.removeAll();
			alert.success(`Le fichier blacklist a été importé correctement`);
			setNeedReload(true)
		})
		.catch((error) => {
			alert.removeAll();
			alert.error(error.response.data.message);
		});
	}

//#endregion

	return (<div style={{height: 'calc(100% - 50px)'}}>
		<TopBar title="Gestion des litiges" className='topbar-contenu' color={props.params.color}
		        buttons={
			        <div className='topbar-buttons'>
				        <input
					        id="fileSelect"
					        type="file"
					        accept=".xlsx"
					        onChange={(e) => uploadDocument(e)}
					        hidden={true}
				        />
				        <MyButton icon={faUpload} label={"Insérer un fichier"} onClick={() => selectFile()}></MyButton>
				        <MyButton onClick={() => navigate("/panneau-administration")} icon={''} label={'Retour'}/>
			        </div>
		        }
		        filterContainer={
			        <>
				        <MySelect name={"filterSelected"} label={"Filtre"} datas={[{key: 1, value: 'Litiges en cours'}, {key: 2, value: 'Litiges archivés'}]}
				                  value={selectedValue.filterSelected}
				                  firstValue={{key: 3, value: 'Tous les litiges'}} handleChange={changeSelectValue}/>
			        </>
		        }
		/>
		<div className='row' style={{margin: 0, overflow: 'hidden'}}>
			<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>
			{!isLoading && (<Paper style={{height: '100%', width: '100%', borderTop: '1px solid #4db4da'}}>
				<TableContainer component={Paper} style={{overflow: 'auto', height: '100%'}}>
					<Table aria-label="simple table">
						<TableHead style={{backgroundColor: '#0094ca'}}>
							<TableRow>
								<TableCell align="center" style={grilleTarifaireStyle.cellHeader}>Actions</TableCell>
								<TableCell align="center" style={grilleTarifaireStyle.cellHeader}>Identifiant du litige</TableCell>
								<TableCell align="center" style={grilleTarifaireStyle.cellHeader}>Utilisateur</TableCell>
								<TableCell align="center" style={grilleTarifaireStyle.cellHeader}>Date de début de litige</TableCell>
								<TableCell align="center" style={grilleTarifaireStyle.cellHeader}>Date de fin de litige</TableCell>
								<TableCell align="center" style={grilleTarifaireStyle.cellHeader}>Archivé</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{listeLitiges.map((litige, index) => (<TableRow key={"row-" + index} style={litige.deleted ? grilleTarifaireStyle.rowDeleted : null}>
								<TableCell align="center">{litige.deleted ? <></> :
									<FontAwesomeIcon icon={faTrash} style={grilleTarifaireStyle.iconTable} onClick={() => handleOnDelete(litige)}/>}</TableCell>
								<TableCell align="center">{litige.litige_id}</TableCell>
								<TableCell align="center"><MyComboBox options={options} readOnly={true} defaultValue={litige.userName}></MyComboBox></TableCell>
								<TableCell align="center"><MyDatePicker type={false} trueValue={litige.date_debut_litige}></MyDatePicker></TableCell>
								<TableCell align="center">{litige.date_fin_litige === null ? null :
									<MyDatePicker type={false} trueValue={litige.date_fin_litige}></MyDatePicker>}</TableCell>
								<TableCell align="center"><FontAwesomeIcon icon={litige.deleted ? faCircleCheck : faCircleXmark}
								                                           style={{color: litige.deleted ? "#a5c946" : "#bb0060", height: '20px'}}/></TableCell>
							</TableRow>))}
							<TableRow>
								<TableCell align="center"> <FontAwesomeIcon icon={faPlus} style={grilleTarifaireStyle.iconTable}
								                                            onClick={() => addNewDispute()}/></TableCell>
								<TableCell align="center"></TableCell>
								<TableCell align="center"><MyComboBox options={options} id="select-user" label="Transporteur"></MyComboBox></TableCell>
								<TableCell align="center"><MyDatePicker label="Date de début de litige" name="dateDebutLitige" trueValue={moment()}
								                                        setTrueValue={addDate} style={grilleTarifaireStyle.classicInput}></MyDatePicker></TableCell>
								<TableCell align="center"><MyDatePicker label="Date de fin de litige" name="dateFinLitige"
								                                        setTrueValue={addDate} style={grilleTarifaireStyle.classicInput}></MyDatePicker></TableCell>
								<TableCell align="center">
									<MySelect name={"deletedSelected"} label={"Archivé"} style={grilleTarifaireStyle.classicInput}
									          value={deletedSelected.deletedSelected}
									          datas={[{key: 1, value: "Archivé"}, {key: 2, value: "En cours"}]} handleChange={changeSelectedDeletedValue}
									          disableClass={true}
									          displayLabel={true}>
									</MySelect>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>)}
		</div>

		<MyDialog open={openDialog} handleClose={setOpenDialog} title='Gestion des litiges' content={content} dialog={setDialogState}/>

	</div>)

}

export default BlackList;
